// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  /* Firefox */
  -moz-appearance: textfield;
}

.wrap {
  position: relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  height: 52px;
  padding: 0px 12px;
  background-color: rgb(255, 255, 255);
}
.wrap .modal-wrap {
  position: absolute;
  background-color: rgb(255, 255, 255);
  top: 55px;
  left: 0px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 6px;
}
.wrap .modal-wrap .country-list {
  margin-top: 10px;
  overflow: -moz-scrollbars-none;
  overflow-y: scroll;
  width: 280px;
  max-height: 250px;
}
.wrap .modal-wrap .country-list::-webkit-scrollbar {
  display: none;
}
.wrap .modal-wrap .modal-country-wrap {
  width: 100%;
  padding: 5px 0px;
}
.wrap .modal-wrap .modal-country-wrap:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.wrap .modal-wrap .search-box {
  border: none;
  outline: none;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 13px;
}
.wrap .input-box {
  border: none;
  outline: none;
  width: 100%;
  padding: 0px 8px;
}
.wrap .text {
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: -0.011px;
}
.wrap .flag {
  width: 20px;
  height: auto;
}

.active {
  border-bottom: 1px solid #0043CE !important;
}

.error {
  border-bottom: 1px solid #DD3130 !important;
}

.border {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.ml-5 {
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/angular-phone-input/angular-phone-number-input.component.scss"],"names":[],"mappings":"AAAA;;EAEI,wBAAA;EACA,SAAA;AACJ;;AAEA;EACI,YAAA;EACA,0BAAA;AACJ;;AAQA;EACI,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAVK;AAKT;AAOI;EACI,kBAAA;EACA,oCAdC;EAeD,SAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;AALR;AAOQ;EACI,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AALZ;AAOY;EACI,aAAA;AALhB;AASQ;EACI,WAAA;EACA,gBAAA;AAPZ;AASY;EACI,oCAvCA;AAgChB;AAWQ;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,2CAAA;EACA,eAAA;AATZ;AAaI;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAXR;AAcI;EACI,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,wBAAA;AAZR;AAeI;EACI,WAAA;EACA,YAAA;AAbR;;AAkBA;EACI,2CAAA;AAfJ;;AAkBA;EACI,2CAAA;AAfJ;;AAkBA;EACI,oCAAA;AAfJ;;AAkBA;EACI,aAAA;AAfJ;;AAkBA;EACI,mBAAA;AAfJ;;AAkBA;EACI,gBAAA;AAfJ","sourcesContent":["input[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type='number'] {\n    /* Firefox */\n    -moz-appearance: textfield;\n}\n\n// colors\n$black-neutral: rgba(0, 0, 0, 0.1);\n$white : rgb(255, 255, 255);\n$blue : #0043CE;\n$red : #DD3130;\n\n.wrap {\n    position: relative;\n    border-bottom: 1px solid $black-neutral;\n    border-radius: 4px;\n    height: 52px;\n    padding: 0px 12px;\n    background-color: $white;\n\n    .modal-wrap {\n        position: absolute;\n        background-color: $white;\n        top: 55px;\n        left: 0px;\n        border: 1px solid $black-neutral;\n        border-radius: 4px;\n        padding: 6px;\n\n        .country-list {\n            margin-top: 10px;\n            overflow: -moz-scrollbars-none;\n            overflow-y: scroll;\n            width: 280px;\n            max-height: 250px;\n\n            &::-webkit-scrollbar {\n                display: none;\n            }\n        }\n\n        .modal-country-wrap {\n            width: 100%;\n            padding: 5px 0px;\n\n            &:hover {\n                background-color: $black-neutral;\n            }\n        }\n\n        .search-box {\n            border: none;\n            outline: none;\n            width: 100%;\n            border-bottom: 1px solid $black-neutral;\n            font-size: 13px;\n        }\n    }\n\n    .input-box {\n        border: none;\n        outline: none;\n        width: 100%;\n        padding: 0px 8px;\n    }\n\n    .text {\n        font-size: 16px;\n        font-weight: normal;\n        line-height: 24px;\n        letter-spacing: -0.011px;\n    }\n\n    .flag {\n        width: 20px;\n        height: auto;\n    }\n}\n\n\n.active {\n    border-bottom: 1px solid $blue !important;\n}\n\n.error {\n    border-bottom: 1px solid $red !important;\n}\n\n.border {\n    border: 1px solid $black-neutral;\n}\n\n.flex {\n    display: flex;\n}\n\n.align-center {\n    align-items: center;\n}\n\n.ml-5 {\n    margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
